
import Pay from './pay.vue'
import Balance from './balance.vue'
import Score from './score.vue'
import Withdraw from './withdraw.vue'

export default {
  Pay,
  Balance,
  Score,
  Withdraw,
}



// WEBPACK FOOTER //
// ./src/views/flowLog/index.js